/* eslint-disable react/button-has-type */
/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['kindTertiaryOutline', 'kindStandardOutline', 'kindTertiarySolid', 'kindPrimary', 'kindPrimarySolid', 'kindPrimarySolid', 'kindDestructiveSolid', 'kindTertiaryLink', 'kindPrimaryLink', 'kindDestructiveLink', 'kindStandardSolid', 'kindTertiaryOutlineSquare', 'kindEditorialSolid', 'kindBrandSolid'] }] */
import 'focus-visible';
import { forwardRef } from 'react';
import classNames from 'classnames';
import { Spinner } from '@teachers/ds-spinner';
import css from './Button.module.scss';
export const buttonVariants = [
    'standardOutline',
    'standardSolid',
    'primarySolid',
    'primaryLink',
    'tertiaryOutline',
    'tertiarySolid',
    'tertiaryLink',
    'tertiaryOutlineSquare',
    'destructiveSolid',
    'destructiveLink',
    'editorialSolid',
    'brandSolid'
];
export const buttonSizes = ['md', 'sm', 'xs'];
const Button = forwardRef((props, ref) => {
    const { activated, className, children, disabled, kind = 'tertiaryOutline', fullWidth, iconLeft: iconLeftProp, iconRight: iconRightProp, loading = false, loadingMessage = '', size, type = 'button', onDark, renderAs, ...restProps } = props;
    const iconLeft = iconLeftProp && (<span className={css.iconLeft}>{iconLeftProp}</span>);
    const iconRight = iconRightProp && (<span className={css.iconRight}>{iconRightProp}</span>);
    const findSpinnerVariant = () => {
        let variant = 'light';
        switch (kind) {
            case 'primarySolid':
            case 'destructiveSolid':
            case 'standardSolid':
            case 'editorialSolid':
            case 'brandSolid':
                variant = 'light';
                break;
            case 'primaryLink':
                variant = 'primary';
                break;
            case 'destructiveLink':
                variant = 'danger';
                break;
            default:
                variant = 'dark';
        }
        return variant;
    };
    const spinnerVariant = findSpinnerVariant();
    const kindsThatSupportActivatedState = kind === 'tertiaryOutline' ||
        kind === 'tertiarySolid' ||
        kind === 'tertiaryLink' ||
        kind === 'tertiaryOutlineSquare';
    const kindsThatSupportonDark = kind === 'standardSolid' ||
        kind === 'standardOutline' ||
        kind === 'tertiarySolid' ||
        kind === 'tertiaryOutline' ||
        kind === 'tertiaryOutlineSquare' ||
        kind === 'tertiaryLink';
    const btnContent = (<div className={css.content}>
        {loading && (<div className={classNames({
        [css.loader]: loading
    })}>
            <Spinner animation="border" variant={spinnerVariant} size="sm" role="status" aria-label={loadingMessage ? undefined : 'Loading'} className={css.spinner}/>
            {loadingMessage && (<span className={css.loaderText}>{loadingMessage}</span>)}
          </div>)}
        <div className={classNames({
        [css.loading]: loading,
        [css.withTextCrop]: size === 'xs'
    })}>
          <div className={css.center}>
            {iconLeft}
            {children}
            {iconRight}
          </div>
        </div>
      </div>);
    const btnClasses = classNames(css.button, css[`kind${kind.charAt(0).toUpperCase() + kind.slice(1)}`], {
        [css.small]: size === 'sm',
        [css.xsmall]: size === 'xs',
        [css.fullWidth]: fullWidth,
        [css.activated]: !loading && activated && kindsThatSupportActivatedState,
        [css.onDark]: onDark && kindsThatSupportonDark
    }, className);
    if (renderAs) {
        return renderAs({
            className: btnClasses,
            children: btnContent
        });
    }
    return (<button ref={ref} type={type} disabled={disabled || loading} className={btnClasses} aria-busy={loading || undefined} {...restProps}>
        {btnContent}
      </button>);
});
Button.displayName = 'Button';
export { Button };
//# sourceMappingURL=Button.jsx.map